import { render, staticRenderFns } from "./ResetPasswordNew.vue?vue&type=template&id=bfbe989e&"
import script from "./ResetPasswordNew.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports